import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'are_wrkrs_restricted_from_leaving_the_workplace_in_order_to_for'

export const dataPointDefinition = {
  retracedId: 'are_wrkrs_restricted_from_leaving_the_workplace_in_order_to_for',
  name: 'Are workers restricted from leaving the workplace in order to force them to work?',
  description:
    'While workers may have required hours and not be able to come and go as they wish without reason, answer Yes if there is an element of coercion or force by the employer making the workers unable to leave.\r\r\n\r\r\nWorkplace refers to the facility buildings (not including the surrounding premises - this is covered separately under the question relating to freedom to leave the dorms and industrial park). \r\r\n',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'fl-9--1',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 10010,
  sectionId: '2.2.7',
  impactArea: 'Forced Labour',
  impactAreaId: 'FORCED_LABOUR',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
